import ReactMarkdown from 'react-markdown';

const ChatMessage = ({ message, onSelectFollowUp }) => {
  return (
    <div
      className={`message-row ${
        message.type === 'user' ? 'user-row' : 'ai-row'
      }`}
    >
      <div
        className={`message-bubble ${
          message.type === 'user' ? 'user-bubble' : 'ai-bubble'
        }`}
      >
        <ReactMarkdown>{message.content}</ReactMarkdown>

        {message.type === 'ai' && message.followUps?.length > 0 && (
          <div className="followup-container">
            {message.followUps.map((followUp) => (
              <button
                key={followUp.id}
                className="prompt-chip followup-chip"
                onClick={() => onSelectFollowUp(followUp)}
              >
                {followUp.question}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
